export const prefixCls = 'mts';

export function useDesign(scope: string) {
  return { prefixCls: `${prefixCls}-${scope}` };
}
